import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMaxPlanckGesellschaftComponent } from './simple-icons-max-planck-gesellschaft.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMaxPlanckGesellschaftComponent ],
    exports:      [ SimpleIconsMaxPlanckGesellschaftComponent ],
    bootstrap:    []
})
export class SimpleIconsMaxPlanckGesellschaftModule {}
